import { ActionTree } from 'vuex';
import { AppState } from '.';
import {
  CHANGE_WORKSPACE,
  GET_INSTALLED_APPS,
  HANDLE_SERIOUS_ERROR,
  LOAD_WORKSPACES,
  SET_CURRENT_APP,
} from './actionTypes';
import {
  ADD_INSTALLED_APP,
  CLEAR_INSTALLED_APPS,
  SET_CURRENT_WORKSPACE,
  SET_ERROR,
  SET_WORKSPACES,
} from './mutationTypes';
import { workspacesApi } from '@/workspaces/workspaces';
import CurrentWorkspaceHelper from '@/workspaces/CurrentWorkspaceHelper';
import { PublishedApp } from '@/features/apps/shared/models';
import router, { updatePageTitle } from '@/router';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { LOAD_CONTACT_ATTRIBUTES } from '@/store/attributes/actionTypes';
import { CLEAR_HOLIDAYS_CACHE } from '@/store/holidays/mutationTypes';
import appInsights from '@/shared/services/appInsights';
import { GET_CHANNEL_IDENTITIES } from '../channel-identities/actionTypes';
import { appsApi } from '@/features/apps/shared/services/apps';
import { CLEAR_FLOWS_CACHE } from '../bot-designer/mutationTypes';
import { CLEAR_INTENTS_CACHE } from '../intents/mutationTypes';
import { CLEAR_ANSWERS_CACHE } from '../answers/mutationTypes';

export const actions: ActionTree<AppState, AppState> = {
  async [LOAD_WORKSPACES]({ commit, dispatch }) {
    try {
      const data: WorkspaceViewModel[] = await workspacesApi.loadAll();

      commit(SET_WORKSPACES, data);
      if (data.length === 0) {
        dispatch(HANDLE_SERIOUS_ERROR, 'No workspaces found');
      }
      CurrentWorkspaceHelper.selectCurrentWorkspace(data, commit);
    } catch (err: any) {
      dispatch(HANDLE_SERIOUS_ERROR, err.message);
    }
  },
  [CHANGE_WORKSPACE]({ commit, dispatch }, workspace: WorkspaceViewModel) {
    CurrentWorkspaceHelper.storeCurrentWorkspace(workspace.id);
    if (router.currentRoute.value.path.includes('/your-apps')) {
      router.push({ name: 'private-apps-list' });
    }
    commit(SET_CURRENT_WORKSPACE, workspace);
    dispatch(LOAD_CONTACT_ATTRIBUTES);
    dispatch(GET_CHANNEL_IDENTITIES, true);
    commit(CLEAR_HOLIDAYS_CACHE);
    commit(CLEAR_INSTALLED_APPS);
    commit(CLEAR_FLOWS_CACHE);
    commit(CLEAR_ANSWERS_CACHE);
    commit(CLEAR_INTENTS_CACHE);

    updatePageTitle();
    appInsights.trackPageView();
  },
  [SET_CURRENT_APP]({ commit }, app: PublishedApp) {
    commit(SET_CURRENT_APP, app);
  },
  [HANDLE_SERIOUS_ERROR]({ commit }, error: string) {
    commit(SET_ERROR, error);
    router.push({ name: 'error' });
  },
  async [GET_INSTALLED_APPS]({ commit, getters }): Promise<void> {
    const apps = await appsApi.getInstalledApps(getters.currentWorkspace.id);

    apps.forEach((app) => {
      commit(ADD_INSTALLED_APP, app.appId);
    });
  },
};
